import { createApiService } from "./baseApi";

/**
 * Cache API Service
 * Uses centralized error handling from baseApi
 */
export const cacheApi = createApiService("cacheApi", (builder) => ({
   listKeys: builder.mutation({
      query: (payload) => ({
         method: "GET",
         url: `cache/keys?pattern=${payload?.pattern || "*"}&database=${payload?.database || 0}&limit=${payload?.limit || 100}`,
      }),
      transformResponse: (result) => result,
   }),

   getKey: builder.mutation({
      query: (payload) => ({
         method: "GET",
         url: `cache/key/${payload?.key}?database=${payload?.database || 0}`,
      }),
      transformResponse: (result) => result,
   }),

   updateKey: builder.mutation({
      query: (payload) => ({
         method: "PUT",
         url: `cache/key/${payload?.key}`,
         body: {
            value: payload?.value,
            database: payload?.database || 0,
            expires: payload?.expires || 0,
            field: payload?.field,
            hashValue: payload?.hashValue,
         },
      }),
      transformResponse: (result) => result,
   }),

   deleteKey: builder.mutation({
      query: (payload) => ({
         method: "DELETE",
         url: `cache/key/${payload?.key}?database=${payload?.database || 0}`,
      }),
      transformResponse: (result) => result,
   }),

   getDatabases: builder.mutation({
      query: () => ({
         method: "GET",
         url: `cache/databases`,
      }),
      transformResponse: (result) => result,
   }),
}));

// Export hooks
export const {
   useListKeysMutation,
   useGetKeyMutation,
   useUpdateKeyMutation,
   useDeleteKeyMutation,
   useGetDatabasesMutation,
} = cacheApi;

